import { IBrandMemberRepositoryResponse, IBrandMembersRequest } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetBrandMemberUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(params: IBrandMembersRequest): Promise<IBrandMemberRepositoryResponse> {
    return this.lookupRepository.getBrandMembers(params);
  }
}
